import React from 'react'

export default function InfoModal({team, close, type}) {

    if (type == 'smart-post') {
        return (
            <div>
                <div>
                    <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
                    <div className="bg-white mx-auto rounded shadow p-5 text-center" style={{ maxWidth: '90%', width: '1000px' }}>
                        <h4>Automatic Multiple Post Guide</h4>

                        <div style={{ textAlign: 'left' }}>
                        <p>
                            <b>Automatic Multiple Post</b> lets you automatically generate multiple posts based on uploaded media files. It works by matching the <b>IMPORT ID</b> in each file’s name to existing users on your team.
                            A <b>template</b> is required to use this feature.
                        </p>

                        Once enabled, the system will:
                        <ul style={{ listStyle: 'inside' }}>
                            <li>Count how many posts to create per user based on media matches</li>
                            <li>Auto-assign post owners using the matched IMPORT ID</li>
                            <li>Attach the correct media files to each post</li>
                            <li>Pre-fill each post using the selected template</li>
                        </ul>

                        <span className='text-danger'>
                            Once media files are uploaded and posts are created, you will not be able to add, remove, or edit those media files.
                        </span>

                        <h5 style={{ textAlign: 'center', marginTop: '16px' }}><b>How to prepare:</b></h5>

                        <ol>
                            <li>
                            Get the <b>IMPORT ID</b> of each sender from their profile or team reports.
                            </li>
                            <li>
                            Rename media files to include the sender’s IMPORT ID using this format: <b>{"{{IMPORT ID}}"}</b>.
                            <br />For example, a user with ID <b>32</b> might have:
                            <br /><code>'Exam Results {`{{32}}`}.pdf', 'Picture {`{{32}}`}.jpg'</code>
                            </li>
                            <li>
                            Upload the media files on the <b>Upload Media Files</b> page. You'll be taken there automatically after saving this setting
                            </li>
                        </ol>

                        <div className="mt-2">
                            <b>Important:</b> If a template is selected, the system will immediately skip manual steps and send you straight to the post list — with everything auto-filled and ready to publish.
                        </div>

                        <div className="mt-3">
                            <b>Note:</b> This feature is currently only available for {team.translations.donor_title.toLowerCase()} and {team.translations.beneficiary_title.toLowerCase()}.
                        </div>
                        </div>

                        <div className="pt-3">
                        <button onClick={close} type="button" className="btn btn-secondary mr-2">
                            Close
                        </button>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        )
    }
  return (
    <div>
        <div>
            <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
                <div className="bg-white mx-auto rounded shadow p-5 text-center" style={{maxWidth: '90%', width: '1000px'}}>
                    <h4>Auto Select Media Guide</h4>

                    <div style={{textAlign: 'left'}}>
                        This feature auto selects the media files for a sender once you select them as the sender for the post,
                        saving you a lot of time in the process, it does so by matching the unique IMPORT ID of the sender to 
                        the name of the media file. You can still manually add and remove media files for that post and you can always 
                        turn this feature on and off mid-post. 
                        <br/>
                        <p style={{textAlign: 'center', marginTop: '10px'}}><b>Follow the instructions below</b></p>

                        <ol>
                            <li>
                                Get the IMPORT ID of the senders you want to use the auto select media feature for, you can get this
                                from their edit profile and team reports 
                            </li> 
                            <li>
                                Add the IMPORT ID of the senders you want to auto select for to their respective media assets in this format 
                                <b>{" {{IMPORT ID}}"}</b> e.g a sender with an IMPORT ID of 32 can have a media file name in the following ways: 
                                {"'Exam Results {{32}}.pdf', 'Picture {{32}}.jpg', etc"}
                            </li>
                            <li>
                                Upload the media files in the upload media files page, you will automatically go to this page after 
                                the settings page, but you can also access it by clicking the 'Edit Media Files' button in the 'Continue Later'
                                dropdown mid-post or the 'Continue' dropdown in the multi-post list
                            </li>
                        </ol>

                        <div>
                            <b>Note: </b> This feature is currently only available for {team.translations.donor_title.toLowerCase()} and 
                            {` ${team.translations.beneficiary_title.toLowerCase()}`}
                        </div>
                    </div>

                    <div className="pt-3">
                        <button onClick={close} type="button" className="btn btn-secondary mr-2">
                            Close
                        </button>
                    </div>
                </div>
            </div>  
        </div>
    </div>
  )
}
